<template lang="pug">
md-input-container(:class='{ "md-input-invalid" : showRequiredError }')
  label {{ multiple ? 'Channels' : 'Channel' }}
  md-select(:multiple='multiple', v-model='selected', @selected='onChannelSelected', :disabled='channels.length === 0')
    md-option(v-for='channel in channels', :value='channel._id', :key='channel._id') {{ channel.name }}
  span.md-error(v-show='showRequiredError') This field is required
</template>

<script>
  import channelService from '../../services/channelService';

  export default {
    props: {
      value: {
        type: [String, Array]
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        channels: []
      };
    },
    methods: {
      onChannelSelected(value) {
        this.$emit('input', value);
      }
    },
    mounted() {
      const params = { filter: 'channels', limit: 100, sortBy: 'name', sortOrder: 'asc' };
      channelService.getGeneralList(params)
        .then((response) => {
          this.channels = response.data.filterOptions;
        })
        .catch(() => {
          this.$emit('getChannelsError');
        });
    },
    watch: {
      value(newValue) {
        this.selected = newValue;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/channel/GeneralChannelSelector.vue